import {
    FETCH_TOTAL_PAGE_VIEW,
    FETCH_TOTAL_PAGE_LIKE,
    FETCH_TOTAL_PAGE_ENGAGEMENT,
    FETCH_TOTAL_PAGE_REACH,
    FETCH_PAGE_VIEW_BY_SECTION,
    FETCH_PAGE_LIKES_BY_LIKE,
    FETCH_PAGE_LIKES_BY_SOURCE,
    UPDATE_FBINSIGHTS_DURATION,
    FETCH_PAGE_VIEW_BY_DEVICE,
    SET_PAGE_VIEW_TAB_INDEX,
    SET_PAGE_LIKES_TAB_INDEX,
    FETCH_TOTAL_POST_LIKES,
    STORE_FB_LOGIN_DETAILS,
    SAVE_SELECTED_FB_PAGE_IDS,
    SET_SELECTED_FB_PAGE,
    FB_PAGE_TOKEN_LIST_FETCHING,
    SET_VIEW_GRID_LINES,
    SET_VIEW_UNIQUE_LINES,
    SET_FOLLOWERS_GRID_LINES,
    SET_FOLLOWERS_UNIQUE_LINES,
    SET_ENGAGEMENT_GRID_LINES,
    SET_ENGAGEMENT_UNIQUE_LINES,
    SET_REACH_GRID_LINES,
    SET_REACH_UNIQUE_LINES,
    SET_POSTS_LIKES_GRID_LINES,
    FB_PAGE_TOKEN_LIST,
    FETCH_AUDIENCE_BY_COUNTRIES,
    FETCH_AUDIENCE_BY_AGE_AND_GENDER,
    FETCH_FB_TOTAL_CHART_DATA,
    FETCH_FB_RECENT_POSTS,
    FETCH_FB_POST_TYPES,
    FETCH_FB_PAGE_FOLLOWERS,
} from "../actions/fbInsightsAction";
import { isFulfilled, isPending } from "./reducerUtils";
const moment = require("moment-timezone");

const initialState = {
    totalPageView: undefined,
    totalPageLikes: undefined,
    totalPageEngagement: undefined,
    totalPostComments: undefined,
    totalPostShares: undefined,
    totalPageReach: undefined,
    totalPageLikesByLike: undefined,
    totalPageViewBySection: undefined,
    totalPageViewByDevice: undefined,
    totalPageLikesBySource: undefined,
    totalPostLikes: undefined,
    audienceByAgeAndGender: undefined,
    audienceByCountries: undefined,
    startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
    endDateTime: moment(new Date()).format("YYYY-MM-DD"),
    duration: "7",
    PageViewChartsTabIndex: 0,
    PageLikesChartsTabIndex: 0,
    PageEngagementChartsTabIndex: 0,
    PageReachChartsTabIndex: 0,
    PostLikesChartsTabIndex: 0,
    rollingDate: false,
    fbPageTokenListFetching: false,
    fbAccessToken: undefined,
    fbUserId: undefined,
    fbAccessTokenExpiry: undefined,
    fbSelectedPageIds: [],
    selectedFbPage: undefined,
    totalViewGridLines: true,
    totalViewUniqueLines: false,
    followersChangeGridLines: true,
    followersChangeUniqueLines: false,
    engagementGridLines: true,
    engagementUniqueLines: false,
    reachGridLine: true,
    reachUniqueLine: false,
    postsLikeGridLine: true,
    fbTotalReachCount: {},
    fbTotalEngagementCount: {},
    fbTotalFollowersCount: {},
    recentPosts: [],
    postTypeDistribution: [],
    impressionsOvertime: undefined,
};

const fbInsightsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TOTAL_PAGE_VIEW:
            return { ...state, totalPageView: action.payload };
        case FETCH_TOTAL_POST_LIKES:
            return { ...state, totalPostLikes: action.payload };
        case FETCH_TOTAL_PAGE_LIKE:
            return { ...state, totalPageLikes: action.payload };
        case FETCH_TOTAL_PAGE_ENGAGEMENT:
            return { ...state, totalPageEngagement: action.payload };

        case "FETCH_TOTAL_PAGE_ENGAGEMENT_RATE":
            return { ...state, totalPageEngagementRate: action.payload };

        case "FETCH_TOTAL_PAGE_FOLLOWERS_DATA":
            return { ...state, pageFollowersData: action.payload };

        case "FETCH_TOTAL_POST_COMMENTS":
            return { ...state, totalPostComments: action.payload };
        case "FETCH_ALL_POST_DETAILS_FOR_CHART_BLOCKS":
            return { ...state, chartBlock: { ...state.chartBlock, ...action.payload } };
        case "FETCH_TOTAL_POST_SHARES":
            return { ...state, totalPostShares: action.payload };
        case FETCH_TOTAL_PAGE_REACH:
            return { ...state, totalPageReach: action.payload };
        case FETCH_PAGE_VIEW_BY_SECTION:
            return { ...state, totalPageViewBySection: action.payload };
        case FETCH_PAGE_VIEW_BY_DEVICE:
            return { ...state, totalPageViewByDevice: action.payload };
        case FETCH_PAGE_LIKES_BY_LIKE:
            return { ...state, totalPageLikesByLike: action.payload };
        case FETCH_PAGE_LIKES_BY_SOURCE:
            return { ...state, totalPageLikesBySource: action.payload };
        case FETCH_AUDIENCE_BY_AGE_AND_GENDER:
            return { ...state, audienceByAgeAndGender: action.payload };
        case FETCH_AUDIENCE_BY_COUNTRIES:
            return { ...state, audienceByCountries: action.payload };
        case FETCH_FB_RECENT_POSTS:
            return { ...state, recentPosts: action.payload };
        case FETCH_FB_POST_TYPES:
            return { ...state, postTypeDistribution: action.payload };
        case isFulfilled(FETCH_FB_TOTAL_CHART_DATA):
            return { ...state, [action.chartKey]: action.payload };
        case "FETCH_FB_POSTS_OVERTIME":
            return { ...state, postsOvertime: action.payload };

        case "FETCH_FB_IMPRESSION_OVERTIME": {
            return { ...state, impressionsOvertime: action.payload };
        }
        case isFulfilled(FETCH_FB_PAGE_FOLLOWERS):
            return { ...state, fbTotalFollowersCount: action.payload };
        case UPDATE_FBINSIGHTS_DURATION: {
            return {
                ...state,
                duration: action.payload.duration,
                startDateTime: action.payload.startDateTime,
                endDateTime: action.payload.endDateTime,
                rollingDate: action.payload.rollingDate,
            };
        }
        case STORE_FB_LOGIN_DETAILS: {
            return {
                ...state,
                fbAccessToken: action.payload.accessToken,
                fbAccessTokenExpiry: action.payload.data_access_expiration_time,
                fbUserId: action.payload.userID,
            };
        }
        case isPending(FB_PAGE_TOKEN_LIST):
            return { ...state, fbPageTokenListFetching: true };
        case isFulfilled(FB_PAGE_TOKEN_LIST): {
            return { ...state, fbSelectedPageIds: action.payload, fbPageTokenListFetching: false };
        }
        case SAVE_SELECTED_FB_PAGE_IDS: {
            return { ...state, fbSelectedPageIds: action.payload };
        }
        case SET_SELECTED_FB_PAGE: {
            if (action.payload === undefined) return;
            return {
                ...state,
                selectedFbPage: action.payload,
                // duration: "7",
                // startDateTime: moment(new Date()).subtract(7, "days").startOf("day").format("YYYY-MM-DD"),
                // endDateTime: moment(new Date()).format("YYYY-MM-DD"),
            };
        }
        // case SET_PAGE_VIEW_TAB_INDEX: {
        //     return { ...state, PageViewChartsTabIndex: action.payload };
        // }
        case SET_PAGE_LIKES_TAB_INDEX: {
            return { ...state, PageLikesChartsTabIndex: action.payload };
        }
        case SET_VIEW_GRID_LINES: {
            return {
                ...state,
                totalViewGridLines: !state.totalViewGridLines,
            };
        }
        case SET_VIEW_UNIQUE_LINES: {
            return {
                ...state,
                totalViewUniqueLines: !state.totalViewUniqueLines,
            };
        }
        case SET_FOLLOWERS_GRID_LINES: {
            return {
                ...state,
                followersChangeGridLines: !state.followersChangeGridLines,
            };
        }
        case SET_FOLLOWERS_UNIQUE_LINES: {
            return {
                ...state,
                followersChangeUniqueLines: !state.followersChangeUniqueLines,
            };
        }
        case SET_ENGAGEMENT_GRID_LINES: {
            return {
                ...state,
                engagementGridLines: !state.engagementGridLines,
            };
        }
        case SET_ENGAGEMENT_UNIQUE_LINES: {
            return {
                ...state,
                engagementUniqueLines: !state.engagementUniqueLines,
            };
        }
        case SET_REACH_GRID_LINES: {
            return {
                ...state,
                reachGridLine: !state.reachGridLine,
            };
        }
        case SET_REACH_UNIQUE_LINES: {
            return {
                ...state,
                reachUniqueLine: !state.reachUniqueLine,
            };
        }
        case SET_POSTS_LIKES_GRID_LINES: {
            return {
                ...state,
                postsLikeGridLine: !state.postsLikeGridLine,
            };
        }

        case "RESET_FB_INSIGHTS_PAGE": {
            return initialState;
        }
        default:
            return state;
    }
};

export default fbInsightsReducer;
